module.exports = __webpack_public_path__ + "img/book.f4aa1cb6.png";